<template>
  <div>
    <Header />

    <header class="header3">
      <div class="container">
        <div class="header3-cont">
          <div class="hd3-cont-left">
            <h1>{{ $tc('accounts_page.accounts_header_text1') }}</h1>
            <div class="hd3-img1">
              <img src="@/assets/images/Accounts/Grupo 1664@2x.png" alt="">
            </div>
          </div>
          <div class="hd3-cont-right">
            <h1>{{ $tc('accounts_page.accounts_header_text2') }}</h1>
            <div class="hd3-img2">
              <img src="@/assets/images/Accounts/Grupo 1668@2x.png" alt="">
            </div>
          </div>
        </div>
      </div>
    </header>

    <section class="midd">
      <div class="container">
        <div class="midd-cont">
          <div class="midd-left">
            <div class="midd-text">
              <h1>{{ $tc('accounts_page.midd_section_h1') }}
              </h1>
              <p>
                {{ $tc('accounts_page.midd_section_p') }}
              </p>
            </div>
          </div>
          <div class="midd-right">
            <div class="midd-r-img">
              <img src="@/assets/images/Accounts/Grupo 1675@2x.png" alt="">
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="info-s">
      <div class="container">
        <div class="info-s-cont">
          <div class="grid-div">
            <div class="grid-item">
              <div class="img-part p1">
                <img src="@/assets/images/Accounts/Grupo 1239@2x.png" alt="">
              </div>
              <h2>{{ $tc('accounts_page.info_s_card1') }}
              </h2>
            </div>
            <div class="grid-item">
              <div class="img-part p2">
                <img src="@/assets/images/Accounts/Grupo 1348@2x.png" alt="">
              </div>
              <h2>{{ $tc('accounts_page.info_s_card4') }}
              </h2>
            </div>
            <div class="grid-item">
              <div class="img-part p3">
                <img src="@/assets/images/Accounts/Grupo 602@2x.png" alt="">
              </div>
              <h2>{{ $tc('accounts_page.info_s_card2') }}
              </h2>
            </div>
            <!--
            <div class="grid-item">
              <div class="img-part p4">
                <img src="@/assets/images/Accounts/Grupo 1351@2x.png" alt="">
              </div>
              <h2>{{ $tc('accounts_page.info_s_card5') }}
              </h2>
            </div> -->
            <div class="grid-item">
              <div class="img-part p5">
                <img src="@/assets/images/Accounts/Grupo 1338@2x.png" alt="">
              </div>
              <h2>{{ $tc('accounts_page.info_s_card3') }}
              </h2>
            </div> <!--
            <div class="grid-item">
              <div class="img-part p6">
                <img src="@/assets/images/Accounts/Grupo 1347@2x.png" alt="">
              </div>
              <h2>Use su Tarjeta de<br>
                Débito* en linea, en la <br>
                tienda o en el cajero <br>
                automatico
              </h2>
            </div> -->
            <div class="grid-item">
              <div class="img-part p7">
                <img src="@/assets/images/Accounts/Grupo 1344@2x.png" alt="">
              </div>
              <h2>{{ $tc('accounts_page.info_s_card6') }}
              </h2>
            </div>
          </div>
        </div>
      </div>
    </section>

    <ContactBox />

    <Footer />
  </div>
</template>

<script>
import Header from '@/components/layout/Header'
import Footer from '@/components/layout/Footer'
import ContactBox from '@/components/ContactBox'

export default {
  name: 'Accounts',

  components: {
    Header,
    Footer,
    ContactBox
  },

  created () {
    document.title = `Cuentas - ${process.env.VUE_APP_TITLE}`
  }
}
</script>
